import styled from 'styled-components'
import { rem } from 'polished'
import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import Divider from 'LuxKit/Divider'
import OfferPageSignUp from './OfferPageSignUp'

const GradientWrapper = styled(LayoutContainer)`
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: ${rem(-200)};
    inset-inline: 0;
    height: ${rem(200)};
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
    pointer-events: none;
  }
`

interface Props {
  offerType: App.OfferType
  saveUpToPercent?: number
}

function OfferPageSignUpWall(props: Props) {
  const { offerType, saveUpToPercent } = props

  return (
    <GradientWrapper>
      <div id="ticket-options" />
      <div id="facilities-all" />
      <div id="soft-wall" />
      <Group direction="vertical" gap={40} tabletGap={80}>
        <Divider kind="primary" />
        <OfferPageSignUp offerType={offerType} saveUpToPercent={saveUpToPercent} />
      </Group>
    </GradientWrapper>
  )
}

export default OfferPageSignUpWall
